import { render } from "./circle-animation2.vue?vue&type=template&id=06e1431b&scoped=true"
const script = {}

import "./circle-animation2.vue?vue&type=style&index=0&id=06e1431b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e1431b"]])

export default __exports__